import { API } from "aws-amplify";

export async function getRecurringTimelapseInterval(kvsName: string): Promise<RecurringTimelapseConfiguration[]> {
  try {
    const path: string = `/timelapse/recurring/${kvsName}`;
    const data = await API.get('api-service', path, {});
    return data.data;
  } catch (error) {
    throw error;
  }
}
